import createCrawlingSessionTab from './create-crawling-session-tab'

export default createCrawlingSessionTab({ type: 'ADVANCED_PROBE_IMAGE' })
